import React from 'react';
import ErrorContainer from './ErrorContainer';

const NotAuthorized = () => (
  <ErrorContainer>
    <div className="error-content">
      <div className="error-status">401</div>
      <div className="error-title">Not authorized</div>
      <div className="error-message">
        You are not authorized to access this content!
      </div>
    </div>
  </ErrorContainer>
);

export default NotAuthorized;
